// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3C1Vo","dragIcon":"Choice_dragIcon__nPw61","left":"Choice_left__2u16w","input":"Choice_input__8515K"};